// Twrad — minimal scroll-reveal observer
// Adds .is-visible to .twrad-reveal elements as they enter viewport.
(function () {
  if (typeof IntersectionObserver === 'undefined') return;
  const reveal = (els) => {
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    for (const el of els) io.observe(el);
  };
  const arm = () => reveal(document.querySelectorAll('.twrad-reveal:not(.is-visible)'));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
  // Also rearm on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', arm);
})();
